import React from 'react';

const Card = ({ children, className = "" }) => {
  return (
    <div className={`bg-transparent shadow-none p-0 ${className}`}>
      {children}
    </div>
  );
};


export default Card;
